import { baseUrl, getTokenFromLocalStorage } from "./Configuration";

export async function GetAllUnprocessedEmails() {
    const url = baseUrl + "/api/UnprocessedEmail";
    try {
        const response = await fetch(url, {
            headers: {
                Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
            },
        });
        if (response.status === 401) {
            localStorage.clear();
            window.location.href = "/login";
            return;
        }
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw error;
    }
}


export async function GetAllUnreadEmails() {
    const url = baseUrl + "/api/UnprocessedEmail/GetUnreadEmail";
    try {
        const response = await fetch(url, {
            headers: {
                Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
            },
        });
        if (response.status === 401) {
            localStorage.clear();
            window.location.href = "/login";
            return;
        }
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw error;
    }
}


export async function GetGroupDetails() {
    const url = baseUrl + "/api/UnprocessedEmail/GroupDetails";
    try {
        const response = await fetch(url, {
            headers: {
                Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
            },
        });
        if (response.status === 401) {
            localStorage.clear();
            window.location.href = "/login";
            return;
        }
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw error;
    }
}

export async function GetFilteredGroupDetails(
    filters: { 
        SelectedApartmentSizes: number[]; 
        selectedApartmentNames: string[]; 
        selectedBuildingNames: string[] 
    },
    pageNumber: number = 1,
    pageSize: number = 10
) {
    const url = `${baseUrl}/api/UnprocessedEmail/GroupDetails?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    
    try {
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
            },
            body: JSON.stringify(filters),
        });
        if (response.status === 401) {
            localStorage.clear();
            window.location.href = "/login";
            return;
        }
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return await response.json();
    } catch (error) {
        console.error("Error fetching filtered data:", error);
        throw error;
    }
}


export async function FetchAppfolioData() {
    const url=baseUrl+"/api/UnprocessedEmail/AppfolioData";
    try {
        const response = await fetch(url, {
            headers: {
                Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
            },
        });
        if (response.status === 401) {
            localStorage.clear();
            window.location.href = "/login";
            return;
        }
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    }
    catch(error){
        console.error("Error fetching filtered data:", error);
        throw error;
    }
    
}